import { render, staticRenderFns } from "./DishPrints.vue?vue&type=template&id=07a123ba&scoped=true&lang=pug"
import script from "./DishPrints.vue?vue&type=script&lang=js"
export * from "./DishPrints.vue?vue&type=script&lang=js"
import style0 from "./DishPrints.vue?vue&type=style&index=0&id=07a123ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a123ba",
  null
  
)

export default component.exports